var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-creditcard"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "creditcard",
    clipPath: "url(#clip-creditcard)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2512",
    "data-name": "Group 2512",
    transform: "translate(-52 -260)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2456",
    "data-name": "Group 2456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2455",
    "data-name": "Group 2455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2454",
    "data-name": "Group 2454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2453",
    "data-name": "Group 2453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2452",
    "data-name": "Group 2452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2451",
    "data-name": "Group 2451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2450",
    "data-name": "Group 2450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2449",
    "data-name": "Group 2449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2448",
    "data-name": "Group 2448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2447",
    "data-name": "Group 2447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2446",
    "data-name": "Group 2446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2445",
    "data-name": "Group 2445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2444",
    "data-name": "Group 2444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2443",
    "data-name": "Group 2443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M80.212,287.1H55.931a3.806,3.806,0,0,1-3.8-3.8V268.476a3.806,3.806,0,0,1,3.8-3.8H80.212a3.806,3.806,0,0,1,3.8,3.8V283.3A3.806,3.806,0,0,1,80.212,287.1Zm-24.281-20.43a1.8,1.8,0,0,0-1.8,1.8V283.3a1.8,1.8,0,0,0,1.8,1.8H80.212a1.8,1.8,0,0,0,1.8-1.8V268.476a1.8,1.8,0,0,0-1.8-1.8Z",
    fill: "#344952"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2473",
    "data-name": "Group 2473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2460",
    "data-name": "Group 2460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2459",
    "data-name": "Group 2459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2458",
    "data-name": "Group 2458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2457",
    "data-name": "Group 2457"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M60.525,279.986H56.337a.5.5,0,0,1,0-1h4.188a.5.5,0,0,1,0,1Z",
    fill: "#344952"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2464",
    "data-name": "Group 2464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2463",
    "data-name": "Group 2463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2462",
    "data-name": "Group 2462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2461",
    "data-name": "Group 2461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M66.952,279.986H62.764a.5.5,0,0,1,0-1h4.188a.5.5,0,0,1,0,1Z",
    fill: "#344952"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2468",
    "data-name": "Group 2468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2467",
    "data-name": "Group 2467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2466",
    "data-name": "Group 2466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2465",
    "data-name": "Group 2465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M73.379,279.986H69.191a.5.5,0,0,1,0-1h4.188a.5.5,0,0,1,0,1Z",
    fill: "#344952"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2472",
    "data-name": "Group 2472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2471",
    "data-name": "Group 2471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2470",
    "data-name": "Group 2470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2469",
    "data-name": "Group 2469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M79.806,279.986H75.619a.5.5,0,0,1,0-1h4.187a.5.5,0,0,1,0,1Z",
    fill: "#344952"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2477",
    "data-name": "Group 2477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2476",
    "data-name": "Group 2476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2475",
    "data-name": "Group 2475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2474",
    "data-name": "Group 2474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M65.275,283.111H56.337a.5.5,0,0,1,0-1h8.938a.5.5,0,0,1,0,1Z",
    fill: "#344952"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2490",
    "data-name": "Group 2490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2481",
    "data-name": "Group 2481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2480",
    "data-name": "Group 2480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2479",
    "data-name": "Group 2479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2478",
    "data-name": "Group 2478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M71.285,276.585a3.953,3.953,0,1,1,3.953-3.953A3.957,3.957,0,0,1,71.285,276.585Zm0-6.906a2.953,2.953,0,1,0,2.953,2.953A2.957,2.957,0,0,0,71.285,269.679Z",
    fill: "#344952"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2485",
    "data-name": "Group 2485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2484",
    "data-name": "Group 2484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2483",
    "data-name": "Group 2483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2482",
    "data-name": "Group 2482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3878",
    "data-name": "Path 3878",
    d: "M76.353,276.585a3.919,3.919,0,0,1-1.542-.314.5.5,0,1,1,.39-.919,2.953,2.953,0,1,0,0-5.44.5.5,0,1,1-.388-.922,3.954,3.954,0,1,1,1.541,7.6Z",
    fill: "#344952"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2489",
    "data-name": "Group 2489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2488",
    "data-name": "Group 2488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2487",
    "data-name": "Group 2487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2486",
    "data-name": "Group 2486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3879",
    "data-name": "Path 3879",
    d: "M73.1,274.247a.5.5,0,0,1-.473-.338,3.708,3.708,0,0,1,0-2.555.5.5,0,0,1,.946.325,2.711,2.711,0,0,0,0,1.906.5.5,0,0,1-.311.635A.51.51,0,0,1,73.1,274.247Z",
    fill: "#344952"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2507",
    "data-name": "Group 2507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2494",
    "data-name": "Group 2494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2493",
    "data-name": "Group 2493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2492",
    "data-name": "Group 2492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2491",
    "data-name": "Group 2491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    d: "M64.337,277.026h-8a.5.5,0,0,1-.5-.5v-4.583a.5.5,0,0,1,.5-.5h8a.5.5,0,0,1,.5.5v4.583A.5.5,0,0,1,64.337,277.026Zm-7.5-1h7v-3.583h-7Z",
    fill: "#344952"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2498",
    "data-name": "Group 2498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2497",
    "data-name": "Group 2497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2496",
    "data-name": "Group 2496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2495",
    "data-name": "Group 2495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    d: "M61.931,277.026H58.744a.5.5,0,0,1-.5-.5v-4.583a.5.5,0,0,1,.5-.5h3.187a.5.5,0,0,1,.5.5v4.583A.5.5,0,0,1,61.931,277.026Zm-2.687-1h2.187v-3.583H59.244Z",
    fill: "#344952"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2502",
    "data-name": "Group 2502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2501",
    "data-name": "Group 2501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2500",
    "data-name": "Group 2500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2499",
    "data-name": "Group 2499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M58.744,274.734H56.337a.5.5,0,0,1,0-1h2.407a.5.5,0,0,1,0,1Z",
    fill: "#344952"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2506",
    "data-name": "Group 2506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2505",
    "data-name": "Group 2505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2504",
    "data-name": "Group 2504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2503",
    "data-name": "Group 2503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    d: "M64.337,274.734H61.931a.5.5,0,1,1,0-1h2.406a.5.5,0,0,1,0,1Z",
    fill: "#344952"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2511",
    "data-name": "Group 2511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2510",
    "data-name": "Group 2510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2509",
    "data-name": "Group 2509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2508",
    "data-name": "Group 2508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    d: "M66.078,269.719H56.337a.5.5,0,0,1,0-1h9.741a.5.5,0,0,1,0,1Z",
    fill: "#344952"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCard);
export default __webpack_public_path__ + "static/media/default-card.29951894819621c2a9c020bd46b92621.svg";
export { ForwardRef as ReactComponent };